import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function ExtFacingIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_ext_facing)">
        <path
          d="M12.3333 7.99996C12.3333 5.60673 10.3932 3.66663 7.99996 3.66663C5.60673 3.66663 3.66663 5.60673 3.66663 7.99996C3.66663 10.3932 5.60673 12.3333 7.99996 12.3333C10.3932 12.3333 12.3333 10.3932 12.3333 7.99996ZM13.3333 7.99996C13.3333 10.9455 10.9455 13.3333 7.99996 13.3333C5.05445 13.3333 2.66663 10.9455 2.66663 7.99996C2.66663 5.05444 5.05444 2.66663 7.99996 2.66663C10.9455 2.66663 13.3333 5.05445 13.3333 7.99996Z"
          fill="currentColor"
        />
        <path
          d="M5.66663 6.16663V3.66663C5.66663 3.39048 5.89048 3.16663 6.16663 3.16663C6.44277 3.16663 6.66663 3.39048 6.66663 3.66663V6.16663C6.66663 7.54737 5.54733 8.66663 4.16663 8.66663H3.33329C3.05715 8.66663 2.83329 8.44277 2.83329 8.16663C2.83329 7.89048 3.05715 7.66663 3.33329 7.66663H4.16663C4.99506 7.66663 5.66663 6.99508 5.66663 6.16663Z"
          fill="currentColor"
        />
        <path
          d="M6.21936 12.1106C6.21936 12.1106 6.22017 12.1085 6.22131 12.1061C6.2237 12.1011 6.22751 12.0921 6.23303 12.08C6.24411 12.0558 6.2611 12.0175 6.28186 11.9668C6.32344 11.8651 6.3802 11.7136 6.43746 11.5227C6.55247 11.1393 6.66663 10.6057 6.66663 9.99996C6.66663 9.53294 6.80373 9.18164 7.06506 8.91207C7.28739 8.6828 7.59353 8.53334 7.77926 8.429C7.9918 8.30958 8.16964 8.19361 8.32353 8.00842C8.47536 7.82571 8.6291 7.54348 8.72782 7.06181L8.76819 6.89709C8.99972 6.07736 9.69124 5.33329 10.6666 5.33329H12C12.2761 5.33329 12.5 5.55715 12.5 5.83329C12.5 6.10944 12.2761 6.33329 12 6.33329H10.6666C10.2613 6.33329 9.87391 6.65697 9.73238 7.15946L9.70764 7.26233C9.58196 7.87556 9.36723 8.31703 9.09241 8.64775C8.81972 8.97581 8.51286 9.16366 8.26884 9.30074C7.99793 9.45293 7.8753 9.51304 7.78316 9.60803C7.73012 9.66273 7.66663 9.75043 7.66663 9.99996C7.66663 10.7275 7.53077 11.3606 7.39579 11.8105C7.32808 12.0362 7.2598 12.2182 7.20764 12.3457C7.18156 12.4094 7.15944 12.4598 7.14319 12.4954C7.13505 12.5132 7.12794 12.5274 7.12301 12.5377C7.12059 12.5428 7.1187 12.5469 7.11715 12.5501C7.11642 12.5516 7.11519 12.554 7.11519 12.554L7.11454 12.5559L7.11389 12.5566C6.99044 12.8035 6.69026 12.9039 6.44332 12.7806C6.19659 12.6572 6.09647 12.3575 6.21936 12.1106Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_ext_facing">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
